import { Component, OnInit, Input, HostBinding, ElementRef, ViewChild } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPictureData } from '../../shared/components/picture/picture.component';
import { ThumbnailBuilderService } from '../board-hero-video-panel/service/thumbnail-builder.service';
import { MqService } from '../../service/mq.service';
import { IVideoViewModel } from '../video-panel/video-panel.component';
import get from 'lodash.get';
import { ILinkWithColor } from 'src/app/shared/interface/link';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { processContent } from '../../shared/utils/rotating-words-utils';
import { IRotatingWords } from '../../shared/interface/rotating-words';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface IBoardHeroPanelData {
  title: IUProperty<string>;
  description: IUProperty<string>;
  rotatingWords?: IUProperty<IRotatingWords[]>;
  media: IUProperty<any>;
  backgroundImage?: IUProperty<IPictureData>;
  overlayImage?: IUProperty<IPictureData>;
  links?: IUProperty<ILinkWithColor[]>;
  linksOrientationc?: IUProperty<string>;
  waves?: IUProperty<string[]>;

  rteStyleSettings?: IRteStyleSettings;
  titleStyleSettings?: ITitleStyleSettings;
  panelSettings?: any;
}

@Component({
  selector: 'app-board-hero-panel',
  templateUrl: './board-hero-panel.component.html',
  styleUrls: ['./board-hero-panel.component.less']
})

export class BoardHeroPanelComponent implements OnInit {
  @Input() data: Partial<IBoardHeroPanelData>;
  @ViewChild('panelElRef', { static: false }) panelElRef: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;

  media: any;
  isDark: boolean;
  thumbnailSrc: string;
  isShow: boolean = false;
  videoData: IVideoViewModel;
  hasImage: boolean;
  topWave: boolean = false;
  bottomWave: boolean = false;
  processedDescription: string = "";
  processedTitle: string = "";

  constructor(
    private thumbnailBuilder: ThumbnailBuilderService,
    private mq: MqService
  ) { }

  ngOnInit() {
    this.prepareMedia();

    this.data.waves.value.forEach(item => {
      switch (item) {
        case 'Top Wave':
          this.topWave = true;
          break;
        case 'Bottom Wave':
          this.bottomWave = true;
          break;
      }
    });
    this.initProcessedText();
  }

  ngAfterViewInit(): void {
    this.applyStyle();
    applyTitleSettings(this.data, this.titleEl);
    requestAnimationFrame(() => {
      this.processTexts();
    });
  }

  private applyStyle() {
    applyRteSettings(this.data, this.descriptionEl);
    if (this.panelElRef && this.panelElRef.nativeElement && this.data && this.data.backgroundImage && this.data.backgroundImage.value) {
      this.panelElRef.nativeElement.style.setProperty('--board-hero-bg-img-src', `url(${this.data.backgroundImage.value.src})`);
    }
  }

  private prepareMedia() {
    try {
      if (!this.data || !this.data.media || !this.data.media.value) return;

      const media = this.data.media.value;

      this.hasImage = !!media.image;

      if (this.hasImage) {
        this.media = media.image;
      } else {
        this.prepareVideo();
      }
    } catch (err) {
      console.error('TODO: fix it please')
    }
  }

  prepareVideo() {
    this.mq.mobileDesktop(this.mobile.bind(this), this.desktop.bind(this));
  }

  mobile() {
    this.videoData = this.prepareVm(get(this.data, 'media.value.video.mobile'));
  }

  desktop() {
    this.videoData = this.prepareVm(get(this.data, 'media.value.video.desktop'));
  }

  open() {
    this.isShow = true;
  }
  close() {
    this.isShow = false;
  }

  private prepareVm(data: any): IVideoViewModel {
    if (!data) return null;

    this.thumbnailSrc = data.thumbnail;

    return {
      thumbnail: this.thumbnailBuilder.create(data.thumbnail),
      title: null,
      description: null,
      videoTitle: null,
      params: `?controls=1&muted=0&autoplay=1&showinfo=0`,
      video: {
        url: data.url,
        type: data.type,
      }
    };
  }

  private processTexts(): void {
    const rotatingWordsData = (this.data.rotatingWords && this.data.rotatingWords.value) ? this.data.rotatingWords.value : [];

    this.processedDescription = processContent(this.processedDescription, rotatingWordsData);
    this.processedTitle = processContent(this.processedTitle, rotatingWordsData, window.getComputedStyle(this.titleEl.nativeElement).fontSize);
  }

  private initProcessedText(): void {
    const rawDescription = (this.data.description && this.data.description.value) ? this.data.description.value : "";
    const rawTitle = (this.data.title && this.data.title.value) ? this.data.title.value : "";

    this.processedDescription = rawDescription;
    this.processedTitle = rawTitle;
  }
}
